import axios from 'axios';
import {BidMode, getBidMode, OPTION_LEVEL_WEIGHTED_PREFERENCE, getLastBidScopeUsed, getStaffId} from '../../scenes/BidSession/helpers.js';
import * as actionTypes from './actionTypes';
import {KINDOFBID, RESERVE_DOWN_TO, VALID_RELATIONS} from '../constants';
import {BID_TYPES} from './../constants/index';
import apiCall from '../app/apiCall';
import * as utils from '../../utilities/calendarUtilities';
import { buildUrlWithAdminImpersonation } from '../../utilities/helpers';

export const fetchBidClassesRequest = () => ({
  type: actionTypes.FETCH_BID_PREFERENCE_CLASSES_REQUEST
});
export const fetchBidClassesFailure = message => ({
  type: actionTypes.FETCH_BID_PREFERENCE_CLASSES_FAILURE,
  message
});
export const fetchBidClassesSuccess = bidPreferenceClasses => ({
  type: actionTypes.FETCH_BID_PREFERENCE_CLASSES_SUCCESS,
  bidPreferenceClasses
});
export const fetchBidOptionsAttributesRequest = () => ({
  type: actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_REQUEST
});
export const fetchBidOptionsAttributesSuccess = (classOptionAttributes, openCombinedPreferences) => ({
  type: actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_SUCCESS,
  classOptionAttributes,
  openCombinedPreferences
});
export const fetchBidOptionsAttributesFailure = response => ({
  type: actionTypes.FETCH_BID_OPTIONS_ATTRIBUTES_FAILURE,
  response
});
export const fetchpairingdate = pairingdate => ({
  type: actionTypes.FETCH_PAIRING_DATE_SUCCESS,
  pairingdate
});

export function savePreference(
  bidSession,
  classOption,
  parameterValues,
  editPreference,
  wish,
  maxnn,
  OptionPropertyId,
  adminComments,
  adminName,
  weight,
  bidmode = getBidMode(),
  optionLevel,
  scoreApplicable
) {
  return () => {
    const savePreferenceUrl = buildUrlWithAdminImpersonation('preferences/save');

    const preferenceOptionPropertyId = OptionPropertyId || getLastBidScopeUsed();

    let bidPreference;
    if (!weight && getBidMode() === BidMode.LADDER.biddingMode) {
      weight = bidSession.nextAvailableLevel;
    }

    // new score for each new preference
    const reserveScores = new Set(); // To track scores for reserve preferences
    const regularScores = new Set(); // To track scores for regular preferences

    let newRegularScore = 1; // Default starting score for regular preferences
    let newReserveScore = 1; // Default starting score for reserve preferences

    const isReserve = preferenceOptionPropertyId === BID_TYPES.RESERVE;

    bidSession.bidPreferences.entries?.forEach(preference => {
    if (isReserve && preference.preferenceOptionPropertyId === BID_TYPES.RESERVE) {
      // Handle reserve preferences
      if (!reserveScores.has(preference.score)) {
        reserveScores.add(preference.score);
        newReserveScore = Math.max(newReserveScore, preference.score + 1); // Increment reserve scores
      }
    } else {
      // Handle regular preferences
      if (!regularScores.has(preference.score)) {
        regularScores.add(preference.score);
        newRegularScore = Math.max(newRegularScore, preference.score + 1); // Increment regular scores
      }
    }
  });

    // Determine the score for a new preference
    const isNewPreferenceReserve = preferenceOptionPropertyId === BID_TYPES.RESERVE;

    const bidMode = getBidMode();
    const scores =
      bidMode === BidMode.LADDER.biddingMode
      ? weight
      : isNewPreferenceReserve
      ? newReserveScore
      : newRegularScore;

    const isOptionLevelInvalid = (optionLevel !== RESERVE_DOWN_TO.minLevel && !optionLevel) || (Number.isInteger(optionLevel) && optionLevel < RESERVE_DOWN_TO.minLevel);
    let weights;
    if (bidMode === BidMode.AUTOMATIC.biddingMode) {
      weights = weight !== undefined ? weight : BidMode.AUTOMATIC.changedWeight;
    } else if (bidMode === BidMode.LADDER.biddingMode) {
      weights = weight !== undefined ? weight : 1;
    } else if (bidMode === BidMode.MANUAL.biddingMode) {
      weights = weight !== undefined ? weight : BidMode.MANUAL.changedWeight;
    } else {
      weights = weight;
    }

    if (bidSession.bidMode === BidMode.MANUAL.biddingMode || bidSession.bidMode === BidMode.LADDER.biddingMode || bidSession.bidMode === BidMode.AUTOMATIC.biddingMode) {
      if (Object.keys(editPreference).length > 0) {
        bidPreference = {
          ...editPreference,
          parameterValues,
          wish,
          maxnn,
          adminComments,
          adminName,
          score: weights,
          bidMode,
          scoreApplicable
        };

        if ((optionLevel !== RESERVE_DOWN_TO.minLevel && !optionLevel) && (bidMode === BidMode.AUTOMATIC.biddingMode || bidMode === BidMode.MANUAL.biddingMode)) {
          bidPreference = {
            ...bidPreference,
            optionLevel: OPTION_LEVEL_WEIGHTED_PREFERENCE
          };
        }
        else {
          bidPreference = {
            ...bidPreference,
            score: isOptionLevelInvalid ? (weights || 2) : 500,
            optionLevel: isOptionLevelInvalid ? OPTION_LEVEL_WEIGHTED_PREFERENCE : optionLevel
          };
        }
      } else {
        bidPreference = {
          bidSessionId: bidSession.currentBid.bidSessionId,
          staffId: getStaffId(),
          preferenceOptionId: classOption,
          preferenceOptionPropertyId,
          score: weights,
          parameterValues,
          wish,
          maxnn,
          adminComments,
          adminName,
          bidMode,
          scoreApplicable
        };

        if (Number.isInteger(optionLevel)) {
          bidPreference = {
            ...bidPreference,
            optionLevel
          };
        }
      }
    } else if (Object.keys(editPreference).length > 0) {
      bidPreference = {
        ...editPreference,
        parameterValues,
        wish,
        maxnn,
        adminComments,
        adminName,
        bidMode,
        scoreApplicable
      };

      bidPreference = {
        ...bidPreference,
        score: isOptionLevelInvalid ? (weights || 2) : 500,
        optionLevel: isOptionLevelInvalid ? OPTION_LEVEL_WEIGHTED_PREFERENCE : optionLevel
      };
    } else {
      bidPreference = {
        bidSessionId: bidSession.currentBid.bidSessionId,
        staffId: getStaffId(),
        preferenceOptionId: classOption,
        preferenceOptionPropertyId,
        score: scores,
        parameterValues,
        wish,
        maxnn,
        adminComments,
        adminName,
        bidMode,
        scoreApplicable
      };

      if (Number.isInteger(optionLevel)) {
        bidPreference = {
          ...bidPreference,
          optionLevel
        };
      }
    }
    // if the user choose LESS_THAN
  if (bidPreference.parameterValues.length > 1) {
      let tempValue;
      if (
        bidPreference.parameterValues[0].parameterRelation ===
        VALID_RELATIONS.LESS_THAN
      ) {
        if (
          KINDOFBID.PARAMETER_CHECK_RENDER_IDS.includes(
            bidPreference.parameterValues[0].parameterId
          )
        ) {
          tempValue = bidPreference.parameterValues[0].value;
          bidPreference.parameterValues[1].value = tempValue;
        }
      }

      if (
        bidPreference.parameterValues[1].parameterRelation ===
        VALID_RELATIONS.LESS_THAN
      ) {
        if (
          KINDOFBID.PARAMETER_CHECK_RENDER_IDS.includes(
            bidPreference.parameterValues[1].parameterId
          )
        ) {
          tempValue = bidPreference.parameterValues[1].value;
          bidPreference.parameterValues[0].value = tempValue;
        }
        if (KINDOFBID.PARAMETER_PARTIAL_OFF.includes(
          bidPreference.parameterValues[1].parameterId)
        ) {
          tempValue = bidPreference.parameterValues[1].value;
          bidPreference.parameterValues[2].value = tempValue;
        }
      }
  }
    return apiCall(savePreferenceUrl, 'post', bidPreference);
  };
}

export function deletePreference(
  bidId,
  employeeBidId,
  adminComments,
  adminName
) {
  return () => {
    const baseUrl = `preferences/delete/?employeebid_id=${employeeBidId}&bidaggregate_id=${bidId}&admin_Comments=${adminComments}&admin_Name=${adminName}`;
    const deletepreferenceUrl = buildUrlWithAdminImpersonation(baseUrl);
    return apiCall(deletepreferenceUrl, 'delete');
  };
}

export const saveCombinedPreference = (combinedPreferences, bidSession, editPreference) => {
  // new score for each new preference
  let newScore
  const bidMode = getBidMode();
  if (
    bidSession.bidMode === BidMode.MANUAL.biddingMode ||
    bidSession.bidMode === BidMode.LADDER.biddingMode ||
    bidSession.bidMode === BidMode.AUTOMATIC.biddingMode
  ) {
    if (bidMode === BidMode.AUTOMATIC.biddingMode) {
        newScore = BidMode.AUTOMATIC.changedWeight;
      } else if (bidMode === BidMode.LADDER.biddingMode) {
        newScore = 0;
      } else {
        newScore = BidMode.MANUAL.changedWeight;
      }
      if(editPreference?.length > 0) newScore = editPreference[0]?.preferences[0]?.score;
      combinedPreferences.preferences.map(preference => preference.score = newScore);
    }
  else {
    if(editPreference?.length > 0){
      newScore = editPreference[0]?.preferences[0]?.score;
      combinedPreferences.preferences.map(preference => preference.score = newScore);
    }
    else {
      const reserveScores = new Set(); // To track scores for reserve preferences
      const regularScores = new Set(); // To track scores for regular preferences

      const optionPropertyId = combinedPreferences.preferences[0]?.preferenceOptionPropertyId;

      let newRegularScore = 1; // Default starting score for regular preferences
      let newReserveScore = 1; // Default starting score for reserve preferences

      const isReserve = optionPropertyId === BID_TYPES.RESERVE;
      bidSession.bidPreferences.entries?.forEach(preference => {
        if (isReserve && preference.preferenceOptionPropertyId === BID_TYPES.RESERVE) {
          // Handle reserve preferences
          if (!reserveScores.has(preference.score)) {
            reserveScores.add(preference.score);
            newReserveScore = Math.max(newReserveScore, preference.score + 1); // Increment reserve scores
          }
        } else {
          // Handle regular preferences
          if (!regularScores.has(preference.score)) {
            regularScores.add(preference.score);
            newRegularScore = Math.max(newRegularScore, preference.score + 1); // Increment regular scores
          }
        }
      });

        // Determine the score for a new preference
        const isNewPreferenceReserve = optionPropertyId === BID_TYPES.RESERVE;
        combinedPreferences.preferences.map(preference => preference.score = isNewPreferenceReserve ? newReserveScore : newRegularScore);
    }
  }

    return () => {
      const savePreferenceUrl = buildUrlWithAdminImpersonation('preferences/combined/save');
      return apiCall(savePreferenceUrl, 'post', combinedPreferences);
    };
}

export const getPreferencesDescription = (bid) => {
  return () => {
    const getPreferencesDescriptionUrl = `preferences/formatDescription`;
    return apiCall(getPreferencesDescriptionUrl, 'post', bid);
  };
}

export const deleteCombinedPreference = (employeeBidId, groupName, adminComments, adminName, lang = 'fr ') => {
  const payload = {
    employeebid_id: employeeBidId,
    bidgroup_name: groupName,
    admin_Comments: adminComments,
    admin_Name: adminName,
    Locale :lang
  }
  return () => {
    const baseUrl = `preferences/combined/delete/?employeebid_id=${employeeBidId}&bidgroup_name=${groupName}&admin_Comments=${adminComments}&admin_Name=${adminName}&Locale=${lang}`;
    const deletepreferenceUrl = buildUrlWithAdminImpersonation(baseUrl);
    return apiCall(deletepreferenceUrl, 'delete', payload);
  };
}

export const copyCombinedPreference = (employeeBidId, groupName) => {
  return () => {
    const copyPreferenceUrl = buildUrlWithAdminImpersonation('preferences/combined/copy');
    const payload = { employeeBidId, groupName }

    return apiCall(copyPreferenceUrl, 'post', payload);
  }
}

export function deleteAllPreferences(staffId, bidSessionId) {
  return () => {
    const baseUrl = `preferences/deleteAll/?staff_id=${staffId}&bidsession_id=${bidSessionId}`;
    const url = buildUrlWithAdminImpersonation(baseUrl);
    return apiCall(url, 'delete');
  };
}

export function fetchClassOptionAttributes(optionClassId, bidSessionId, openCombinedPreferences, staffIdOverride = null) {
  return dispatch => {
    dispatch(fetchBidOptionsAttributesRequest());
    // Use staffIdOverride if provided (for admin/crew group default), otherwise use getStaffId()
    const staffId = staffIdOverride || getStaffId();
    const classOptionAttributesUrl = `preferences/options/${optionClassId}?bidsession_id=${bidSessionId}&staff_id=${staffId}`;
    apiCall(classOptionAttributesUrl, 'get')
      .then(response => {
        const classOptionAttributes = response.data;
        return dispatch(
          fetchBidOptionsAttributesSuccess(classOptionAttributes, openCombinedPreferences)
        );
      })
      .catch(e => dispatch(fetchBidOptionsAttributesFailure(e)));
  };
}

export function fetchBidPreferenceClasses(
  applicationType,
  optionPropertyId,
  categoryId,
  bidSessionId,
  staffId,
  combined,
  isComponentMounted = () => true
) {
  return dispatch => {
    dispatch(fetchBidClassesRequest());
    const getPreferenceClassesUrl = `preferences/classes?application_type=${applicationType}&property_code=${optionPropertyId}&bidsession_id=${bidSessionId}&category_id=${categoryId}&combined_bid=${combined}&staff_id=${staffId}`;
    const getPreferenceOptions = `preferences/options?application_type=${applicationType}&property_code=${optionPropertyId}&bidsession_id=${bidSessionId}&category_id=${categoryId}&combined_bid=${combined}&staff_id=${staffId}`;
    axios
      .all([
        apiCall(getPreferenceClassesUrl, 'get'),
        apiCall(getPreferenceOptions, 'get')
      ])
      .then(
        axios.spread((preferenceClassesResponse, preferenceOptionsResponse) => {
          if (!isComponentMounted()) {
            return;
          }
          const preferenceClasses = preferenceClassesResponse.data;
          const preferenceOptions = preferenceOptionsResponse.data;

          preferenceClasses.entries.map(
            preferenceClass =>
              (preferenceClass.options = preferenceOptions.entries.filter(
                option =>
                  option.preferenceClassId === preferenceClass.preferenceClassId
              ))
          );
          return dispatch(
            fetchBidClassesSuccess({
              preferenceClasses,
              preferenceOptions,
              dialogNextState: true
            })
          );
        })
      )
      .catch(e => dispatch(fetchBidClassesFailure(e)));
  };
}
export function fetchdate(pairingName, staffId, bidStart, bidOptionId) {
  return dispatch => {
    const dateUrl = `preferences/bid-sessions/pairing/active-dates/?pairingName=${pairingName}&staffId=${staffId}&bidOptionId=${bidOptionId}`;
    apiCall(dateUrl, 'get').then(response => {
      const datearray = [];
      const data = response.data;
      data.forEach((arrayItem) => {
        const activeDate = utils.arrayDateToUtcStringWithNoTime(arrayItem.activityStartDate);
        datearray.push(activeDate);
      });
      dispatch(fetchpairingdate(datearray));
    });
  };
}
